module.exports = __webpack_public_path__ + "img/Objetivo 4.97adb469.png";